import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';
import { standAlone } from './epi-api';

const benAdminOnlyQuery = (affix, groupId?: number) => standAlone ? `${affix}cpg_admin_group_filter=${groupId || 'ALL'}` : '';
const formParamName = standAlone ? 'cpg_admin_group_filter' : 'groups';

export const getBillingAccounts = (groupId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/group/${groupId}.json`,
		onSuccess,
		onFailure,
	});
};

export const getBillingAccountDetails = (billingAccountId: string, groupId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/group/${groupId}/accounts/${billingAccountId}.json`,
		onSuccess,
		onFailure,
	});
};

export const getGroups = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/group.json`,
		onSuccess,
		onFailure,
	});
};

export const getAnnualEnrollmentInfo = (guid: string, completedStatus: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any, groupId?: number): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/enrollment/${guid}/enrollment_form/annual/?completed=${completedStatus}${benAdminOnlyQuery('&', groupId)}`,
		onSuccess,
		onFailure,
	});
};

export const getAnnualEnrollmentStatus = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/enrollment/${guid}/enrollment_form/annual/status${benAdminOnlyQuery('?')}`,
		onSuccess,
		onFailure,
	});
};

export const getAnnualEnrollmentTierCalc = (groupId: number | string, tierCount: number, spouseCount: number, childCount: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/enrollment/tiercalc/group/${groupId}/tiers/${tierCount}/spouses/${spouseCount}/children/${childCount}${benAdminOnlyQuery('?')}`,
		onSuccess,
		onFailure,
	});
};


export const getMidYearEnrollmentInfo = (groupId: number, guid: string, complete: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/enrollment/${guid}/enrollment_form/regular/?completed=${complete}&${formParamName}=${groupId}`,
		onSuccess,
		onFailure,
	});
};

export const getMidYearEnrollmentStatus = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/enrollment/${guid}/enrollment_form/regular/status${benAdminOnlyQuery('?')}`,
		onSuccess,
		onFailure,
	});
};

export const postMidYearEnrollment = (guid: string, groupId: number, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/enrollment/${guid}/enrollment_form/regular/?${formParamName}=${groupId}`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postAnnualEnrollment = (guid: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any, groupId?: number): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/enrollment/${guid}/enrollment_form/annual${benAdminOnlyQuery('?', groupId)}`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getExternalLinks = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/links.json`,
		onSuccess,
		onFailure,
	});
};

export const getProductSummary = (groupId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/offerings/group/${groupId}`,
		onSuccess,
		onFailure,
	});
};


export const getGroupLifeContractList = (groupId: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/document/static_group/group_life_contract_list/group/${groupId}`,
		onSuccess,
		onFailure,
	});
};

export const getCurrentCycle = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/system`,
		onSuccess,
		onFailure,
	});
};

export const getPersonBenefitFacts = (guid: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/process/person_benefit_facts/${guid}`,
		onSuccess,
		onFailure,
	});
};

export const getNewHireCoverageEnrollment = (employeeId: string, queryString: string, employerId: string, eventType: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/members/${employeeId}/plans?${queryString}=${employerId}&qualified_event=${eventType}`,
		onSuccess,
		onFailure,
	});
};

export const postNewHireCoverageEnrollment = (employeeId: string, queryString: string, employerId: string, payloadData: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/members/${employeeId}/plans?${queryString}=${employerId}`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getGhlForms = (personGuid: number | string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/members/${personGuid}/ghl_forms.json`,
		onSuccess,
		onFailure,
	});
};

export const getVolumeForSpecificPlans = (groupId: string, employment_id: number | unknown, volume: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/rules/group_life_rate.json?group_id=${groupId}&employment_id=${employment_id}&volume=${volume}`,
		onSuccess,
		onFailure,
	});
};


export const postGhlForm = (employeeId: string, payloadData: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/members/${employeeId}/ghl_forms.json`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getMemberCoverage = (memberGuid: string, id: number, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/members/${memberGuid}/ghl_forms/${id}.json`,
		onSuccess,
		onFailure,
	});
};

export const postMemberGhlForm = (employeeId: string, employerId: string, formId: number, payloadData: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/members/${employeeId}/plans?employer_id=${employerId}&ghl_form_id=${formId}`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getPendingApprovalGhlForms = (onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/members/ghl_forms/pending.json`,
		onSuccess,
		onFailure,
	});
};

export const getDioApproverNewHireCoverageEnrollment = (employeeId: string, formId: number, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.mlps}/members/${employeeId}/ghl_forms/${formId}/pending_approval.json`,
		onSuccess,
		onFailure,
	});
};

export const postDioApproverRejectGhlForm = (formId: number, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/members/ghl_forms/${formId}/reject`,
		onSuccess,
		onFailure,
	});
};

export const postDioApproverApproverGhlForm = (formId: number, employee_guid: string, payloadData: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/members/${employee_guid}/ghl_forms/${formId}/approve`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postLifeEvent = (guid: string, payloadData: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/members/${guid}/ghl_forms/life_events`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getOpenEnrollmentWindow = (guid: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/members/${guid}/ghl_forms/life_events`,
		onSuccess,
		onFailure,
	});
};


export const getPendingForApprovalForms = (guid: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/members/${guid}/ghl_forms/life_events/pending_admin_approval`,
		onSuccess,
		onFailure,
	});
};

export const getMidYearCoverage = (guid: string, formId: number, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/members/${guid}/ghl_forms/life_events/${formId}`,
		onSuccess,
		onFailure,
	});
};

export const postMidYearCoverageEnrollment = (employeeId: string, formId: number, payloadData: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.mlps}/members/${employeeId}/ghl_forms/life_events/${formId}`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getOePlanOffering = (institutionClientNumber: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/employers/${institutionClientNumber}/oe_plan_offerings`,
		onSuccess,
		onFailure,
	});
};

export const postOePlanOffering = (institutionClientNumber: string, payloadData: any, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.mlps}/employers/${institutionClientNumber}/oe_optouts`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const getAllExistingEnrollment = (clientGuid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.mlps}/members/${clientGuid}/coverage_status`,
		onSuccess,
		onFailure,
	});
};